<template>
  <div>
    <MainCard v-if="!isLoadingTable">
      <template v-slot:body>
        <DataTablePagination
          :total-items="totalItems"
          :headers="headers"
          :search="search"
          :items="attendances"
          :page="page"
          :no-add-button="noAddButton"
          :print-recap-button="printRecapButton"
          :filter-student-attendance="filterStudentAttendance"
          :classes="classes"
          :total-pages.sync="totalPages"
          :is-loading="isLoadingData"
          title="Absensi Siswa"
          subtitle="Halaman untuk absensi siswa "
          @page="page"
          @change-page="paginationHandler"
          @live-search="searchHandler"
          @filter-classes="handleFilterClass"
          @filter-from-date-atd="handleFromDateAtd"
          @filter-to-date-atd="handleToDateAtd"
        >
        </DataTablePagination>
      </template>
    </MainCard>
    <SkeletonLoaderTable v-else></SkeletonLoaderTable>
  </div>
</template>

<script>
import DataTablePagination from '@/views/components/DataTablePagination.vue'
import MainCard from '@/views/components/MainCard.vue'
import SkeletonLoaderTable from '@/views/components/SkeletonLoaderTable.vue'

export default {
  name: 'AttendanceStudentHeadMaster',
  components: {
    DataTablePagination,
    SkeletonLoaderTable,
    MainCard,
  },
  data() {
    return {
      dialog: '',
      search: '',
      class: '',
      modalDialog: false,
      confirmDialog: false,
      isLoadingTable: true,
      isLoadingData: false,
      isLoadingButton: false,
      printRecapButton: true,
      noAddButton: true,
      filterClass: true,
      filterStudentAttendance: true,
      page: 1,
      totalPages: 1,
      totalItems: 1,
      service: 'attendance',
      headers: [
        { text: 'No', value: 'index' },
        { text: 'Nama Lengkap', value: 'full_name' },
        { text: 'Kelas', value: 'class[0].name' },
        { text: 'Hadir (H)', value: 'hadir' },
        { text: 'Alfa (A)', value: 'alpha' },
        { text: 'Sakit (S)', value: 'sakit' },
        { text: 'Izin (I)', value: 'izin' },
        { text: 'Aksi', value: 'attendanceActions' },
      ],
      students: [],
      classes: [],
      attendances: [],
      school: '',
      school_uuid: '',
      user_uuid: '',
      from_date_atd: '',
      to_date_atd: '',
    }
  },
  watch: {
    class: {
      handler() {
        this.listAttendanceStudent({ class_uuid: this.class })
      },
    },
  },
  mounted() {
    this.getSchoolUuid()
    this.listAttendanceStudent()
    this.listClass()
  },
  methods: {
    getSchoolUuid() {
      this.school = JSON.parse(localStorage.getItem('user')).user.details
      this.school.forEach(el => {
        if (el.school === undefined) {
          this.school_uuid = el.uuid

          return
        }
        if (el.school === null) {
          this.showSnackbar({
            text: "You don't have access to school",
            color: 'error',
          })

          return
        }
        this.school_uuid = el.school.uuid
      })

      return true
    },
    async listClass() {
      await this.$services.ApiServices.list('class', { school_uuid: this.school_uuid }).then(
        ({ data }) => {
          this.classes.push(...data.data)
        },
        err => console.error(err),
      )
    },
    async listAttendanceStudent(params = {}) {
      this.isLoadingData = true
      await this.$services.ApiServices.list(this.service, {
        ...params,
        school_uuid: this.school_uuid,
        page: this.page,
        class_uuid: this.class,
        start_date: this.from_date_atd,
        end_date: this.to_date_atd,
      }).then(
        ({ data }) => {
          this.attendances = data.data.map((attendances, index) => ({
            ...attendances,
            index: index + 1,
          }))
          this.totalPages = data.meta.last_page
          this.totalItems = data.meta.total
        },
        err => {
          console.error(err)
        },
      )
      this.isLoadingTable = false
      this.isLoadingData = false
    },

    paginationHandler(pageNumber) {
      this.page = pageNumber
    },

    searchHandler(search) {
      this.search = search
      this.listAttendanceStudent({ search })
    },

    handleFilterClass(uuid) {
      this.class = uuid
      if (uuid === null) {
        this.class = ''
      }
    },

    handleFromDateAtd(date) {
      this.from_date_atd = date
      this.listAttendanceStudent({ start_date: date })
    },

    handleToDateAtd(date) {
      this.to_date_atd = date
      this.listAttendanceStudent({ end_date: date })
    },
  },
}
</script>

<style>
</style>
